import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/frontend-next/src/app/_ui/components/core/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkTracked"] */ "/app/frontend-next/src/app/_ui/components/core/LinkTracked.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.8.3_@swc+helpers@0.5.19_next@16.2.6_patch_hash=87bd3be122de7f07fc22e77058ef_6b4f757aeed4e03e447253a7e2efd2f7/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
